import React from "react";
import { Modal } from "react-bootstrap";
import UNCTAD_AWARD from "../../assets/UNCTAD_AWARD.jpg";

export default function AwardAdvertise(props) {
  const { show, closeModal } = props;

  return (
    <React.Fragment>
      <Modal show={show} dialogClassName="banner-modal" onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Message from Hon'ble Prime Minister</Modal.Title>
        </Modal.Header>

        <Modal.Body className="pmg-body">
          <img src={UNCTAD_AWARD} style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
